import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from '../../../../ui/gridSystem';
import {
  CTA,
  CustomInput,
  CustomSelect,
  Icon,
  NoResult,
  Text,
} from '../../../../ui/atoms';
import {
  InfoBox,
  Card,
  CourseCard,
  FiltersWrapper,
  Legend,
  SortingWrapper,
  TitleWrapper,
  InfoBoxMobile,
  CardsWrapper,
  ChartsWrapper,
  ChartLegend,
  ColorBox,
  RefreshAndLegend,
  LegendItem,
} from './style';
import CircularStats from '../../../../ui/atoms/CircularStats';
import routes from '../../../../routes';
import { MODAL_OPEN } from '../../../redux/actions';
import { withMediaQueries } from '../../../hoc/withMediaQueries';
import SortBy from '../../../../ui/atoms/SortBy';
import Pagination from '../../../../ui/atoms/Pagination';
import { timestampToDate } from '../../../../utils/common';
import ModalUserList, {
  ModalUserListId,
} from '../../../../ui/atoms/Modals/ModalUserList';
import { ModalDownloadReportId } from '../../../../ui/atoms/Modals/ModalDownloadReport';
import {
  COURSE_CREATED_LIST_GET,
  MY_USERS_GET,
  USER_STATS_GET,
} from '../../../redux/actions/statistics';
import {
  COURSE_TYPOLOGY_OPTIONS,
  VISIBILITY_OPTIONS,
  formatFilterOpt,
  getFilterLabel,
  getFilterOptions,
  getSortingOptions,
} from '../../../../utils/labels';
import { FFOO_GET } from '../../../redux/actions/courselist';
import theme from '../../../../ui/theme';
import Inline from '../../../../ui/atoms/Inline';
import { generateColorPalette } from '../../../../utils/colors';
import TimeIntervalFilter from '../../../../ui/atoms/TimeIntervalFilter';
import Breadcrumb from '../../../../ui/atoms/Breadcrumb';
import RefreshBtn from '../../../../ui/atoms/RefreshBtn';
import { getCurrentMonthDate } from '../../../../utils/stats-date';

const TutorStatistics = ({
  mediaIsPhone,
  mediaIsTablet,
  list,
  pager,
  filters,
  user,
  modalOpen,
  getCourseCreatedList,
  myUsers,
  getMyUsers,
  getFfoo,
  ffoo,
  getUserStats,
}) => {
  const { user_id } = useParams();
  const navigate = useNavigate();
  const currentMonth = getCurrentMonthDate();
  // filters
  const [myUsersFilters, setMyUsersFilters] = useState({
    filter: 'ffoo',
    start_date: currentMonth.start_date,
    end_date: currentMonth.end_date,
  });
  const [selectedFilters, setSelectedFilters] = useState({});
  const [searchValue, setSearchValue] = useState();
  const [reducedStats, setReducedStats] = useState();

  useEffect(() => {
    if (user_id && !user?.id) getUserStats(user_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id]);

  useEffect(() => {
    if (mediaIsPhone || mediaIsTablet) setReducedStats(true);
    else setReducedStats(false);
  }, [mediaIsPhone, mediaIsTablet]);

  useEffect(() => {
    handleGetCourses();
    getFfoo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetCourses = (page) => {
    const parsedFilters = {
      ...selectedFilters,
      page,
    };
    getCourseCreatedList(parsedFilters);
  };

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) handleGetCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  useEffect(() => {
    getMyUsers(myUsersFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myUsersFilters]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    if (key === 'categories') newFilters.parent_categories = value?.value;
    else newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handleGetCourses(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  const formatUsers = ({ items: users }) => {
    const formattedUsers = {};
    users?.forEach((u) => {
      formattedUsers[u?.label] = u?.count;
    });
    return formattedUsers;
  };

  const getDataLabels = (users) => {
    return (users?.assignments?.items || []).map(({ label }) => label);
  };

  return (
    <>
      {user_id && (
        <Breadcrumb
          crumbs={[
            {
              label: 'Statistiche',
              onClick: () => navigate(routes.statistics.path),
            },
            {
              label: `${user?.first_name || ''} ${user?.last_name || ''}`,
              onClick: () =>
                navigate(`${routes.tutorStatistics.path}/${user_id}`),
            },
            {
              label: `Dashboard di ${user?.first_name || ''} ${
                user?.last_name || ''
              }`,
            },
          ]}
        />
      )}
      <Container className={user_id ? 'pt-0' : ''}>
        <TitleWrapper>
          <div>
            <Text type="h1">{user_id ? 'Dashboard di:' : 'Statistiche'}</Text>
            {user_id && (
              <Text type="h2">
                {user?.first_name || ''} {user?.last_name || ''}
              </Text>
            )}
          </div>
          {!reducedStats ? (
            <InfoBox className="d-flex sb">
              <Text type="b4">
                Vuoi consultare i report anche offline dal tuo computer?
                Effettua il download delle statistiche
              </Text>
              <CTA
                type="tertiary"
                btnText="Download statistiche"
                icon="download-01"
                onClick={() => modalOpen(ModalDownloadReportId)}
              />
            </InfoBox>
          ) : (
            <InfoBoxMobile>
              <Icon
                type="monitor-03"
                size={40}
                fill="none"
                stroke={theme().colors.darkerBlue}
                strokeWidth={1.5}
              />
              <Text type="b4">
                Per navigare tutti i contenuti riguardanti le statistiche
                effettua l'accesso via web tramite computer!
              </Text>
            </InfoBoxMobile>
          )}
        </TitleWrapper>
        <Card>
          <div className="d-flex sb">
            <Text type="h2.5">Utenti</Text>
            {!reducedStats && (
              <CTA
                type="tertiary"
                btnText="Tutti gli utenti"
                icon="arrow-narrow-right"
                bottomRight
                onClick={() => modalOpen(ModalUserListId)}
              />
            )}
          </div>
          <div className="filters-wrapper">
            <Text type="b5">
              Seleziona il periodo temporale e la tipologia di filtro:
            </Text>
            <TimeIntervalFilter
              size={mediaIsPhone ? 'full' : 's'}
              callback={(start_date, end_date) => {
                setMyUsersFilters({
                  ...myUsersFilters,
                  start_date,
                  end_date,
                });
              }}
              defaultStartDate={getCurrentMonthDate()}
              defaultEndDate={getCurrentMonthDate()}
            />
            <CustomSelect
              options={(myUsers?.filters?.filter ?? []).map((opt) =>
                formatFilterOpt(opt)
              )}
              size={mediaIsPhone ? 'full' : 'compact'}
              onChange={({ value }) =>
                setMyUsersFilters({
                  ...myUsersFilters,
                  filter: value,
                })
              }
              selected={(myUsers?.filters?.filter ?? [])
                .map((opt) => formatFilterOpt(opt))
                ?.filter((item) => item.value === myUsersFilters?.filter)}
            />
          </div>
          <ChartsWrapper>
            <div className="d-flex sb chart-container">
              <div>
                <Text type="h3.5" mb={16}>
                  Assegnazioni
                </Text>
                <Text type="b5">
                  Panoramica degli utenti che visualizzano almeno uno dei tuoi
                  percorsi formativi
                </Text>
              </div>
              <div className="chart-wrapper">
                <CircularStats
                  label="Utenti totali"
                  size={mediaIsPhone ? 190 : 130}
                  data={formatUsers(myUsers?.assignments)}
                  chartOnly
                  mt={0}
                />
              </div>
            </div>
            <div className="d-flex sb chart-container">
              <div>
                <Text type="h3.5" mb={16}>
                  Fruizioni
                </Text>
                <Text type="b5">
                  Panoramica degli utenti che fruiscono di almeno uno dei tuoi
                  percorsi formativi
                </Text>
              </div>
              <div className="chart-wrapper">
                <CircularStats
                  label="Utenti totali"
                  size={mediaIsPhone ? 190 : 130}
                  data={formatUsers(myUsers?.fruitions)}
                  dataLabels={getDataLabels(myUsers)}
                  chartOnly
                  mt={0}
                />
              </div>
            </div>
            <div className="d-flex sb chart-container last">
              <div>
                <Text type="h3.5" mb={16}>
                  Completamenti
                </Text>
                <Text type="b5">
                  Panoramica degli utenti che hanno completato almeno uno dei
                  tuoi percorsi formativi
                </Text>
              </div>
              <div className="chart-wrapper">
                <CircularStats
                  label="Utenti totali"
                  size={mediaIsPhone ? 190 : 130}
                  data={formatUsers(myUsers?.completions)}
                  dataLabels={getDataLabels(myUsers)}
                  chartOnly
                  mt={0}
                />
              </div>
            </div>
          </ChartsWrapper>
          <RefreshAndLegend>
            {!mediaIsPhone && (
              <RefreshBtn
                cacheTag={myUsers?.cache_tag}
                callback={() => getMyUsers(myUsersFilters)}
              />
            )}
            <ChartLegend>
              {(myUsers?.assignments?.items || []).map((item, i) => (
                <LegendItem key={`legend-item-${i}`}>
                  <ColorBox
                    color={
                      generateColorPalette(myUsers?.assignments?.items?.length)[
                        i
                      ]
                    }
                  />
                  <Text type="b5" className="ellipsis">
                    {item?.label}
                  </Text>
                </LegendItem>
              ))}
            </ChartLegend>
          </RefreshAndLegend>
          {mediaIsPhone && (
            <div style={{ order: 99 }}>
              <RefreshBtn
                cacheTag={myUsers?.cache_tag}
                callback={() => getMyUsers(myUsersFilters)}
              />
            </div>
          )}
        </Card>
        {!reducedStats && (
          <>
            <Text type="h2" mb={32}>
              Report percorsi formativi
            </Text>
            <FiltersWrapper>
              <CustomInput
                size={429}
                placeholder="Cosa vuoi cercare?..."
                isSearch
                value=""
                icon="search-sm"
                isClearable
                onChange={(v) => setSearchValue(v)}
                onClickIcon={onClickSearch}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') onClickSearch();
                }}
              />
              <CustomSelect
                size="s"
                wrapperId="filter-typology"
                placeholder="Tipologia"
                options={COURSE_TYPOLOGY_OPTIONS}
                onChange={(value) => handleOnChange({ key: 'typology', value })}
                isClearable
              />
              {(Object.keys(filters || {}) || []).map((key, i) => (
                <CustomSelect
                  size="s"
                  key={`filter-${i}`}
                  wrapperId={`filter-${key}`}
                  placeholder={getFilterLabel(key)}
                  options={getFilterOptions(filters, key)}
                  onChange={(value) => handleOnChange({ key, value })}
                  isClearable
                />
              ))}
              <CustomSelect
                size="s"
                wrapperId="filter-ffoo"
                placeholder="Forze dell'ordine"
                options={ffoo.map((opt) => ({
                  label: opt.name,
                  value: opt.id,
                }))}
                onChange={(value) =>
                  handleOnChange({ key: 'visible_ffoo', value })
                }
                isClearable
              />
              <CustomSelect
                size="s"
                wrapperId="filter-published"
                placeholder="Stato"
                options={VISIBILITY_OPTIONS}
                onChange={(value) =>
                  handleOnChange({ key: 'published', value })
                }
                isClearable
              />
            </FiltersWrapper>
            <SortingWrapper>
              <SortBy
                options={getSortingOptions(['publication_asc', 'alphabetical'])}
                onChange={(v) => {
                  setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
                }}
              />
            </SortingWrapper>
            {list?.length > 0 ? (
              <>
                <Legend>
                  <Text type="statistics-heading">Codice</Text>
                  <Text type="statistics-heading">
                    Titolo percorso formativo
                  </Text>
                  <Text type="statistics-heading">Area Tematica</Text>
                  <Text type="statistics-heading">Assegnazioni</Text>
                  <Text type="statistics-heading">Fruizioni</Text>
                  <Text type="statistics-heading">Completamenti</Text>
                  <Text type="statistics-heading">Stato</Text>
                  <Text type="statistics-heading">Data di pubblicazione</Text>
                </Legend>
                <CardsWrapper hasPaginator={pager?.number_of_pages > 1}>
                  {list.map((item) => (
                    <CourseCard key={`card-${item.id}`}>
                      <Text type="b5" className="uppercase">
                        {item?.code}
                      </Text>
                      <div className="ellipsis">
                        {item?.typology && (
                          <Text type="b4" className="typology">
                            {item?.typology === 'event' ? 'Evento' : 'Corso'}
                          </Text>
                        )}
                        <Text
                          type="h3"
                          className="ellipsis"
                          onClick={() =>
                            navigate(
                              `${routes.courseStatistics.path}/${item.id}/${
                                item?.typology === 'event'
                                  ? 'sessioni'
                                  : 'attività'
                              }`
                            )
                          }
                        >
                          {item.title}
                        </Text>
                      </div>
                      <Text
                        type="b4"
                        className="ellipsis"
                        color={theme().colors.primaryDarkGray900}
                      >
                        {item?.category}
                      </Text>
                      <Text type="b2">{item?.assignments ?? 0}</Text>
                      <div>
                        <Inline alignItems="baseline">
                          <Text type="b2">{item?.fruitions ?? 0}</Text>
                          <Text type="b4">/{item?.assignments ?? 0}</Text>
                        </Inline>
                        {item?.fruitions && item?.assignments > 0 && (
                          <Text type="b5">
                            {Math.round(
                              (item.fruitions / item.assignments) * 100
                            )}
                            %
                          </Text>
                        )}
                      </div>
                      <div>
                        <Inline alignItems="baseline">
                          <Text type="b2">{item?.completions ?? 0}</Text>
                          <Text type="b4">/{item?.assignments ?? 0}</Text>
                        </Inline>
                        {typeof item?.completions === 'number' &&
                          item?.assignments > 0 && (
                            <Text type="b5">
                              {Math.round(
                                (item.completions / item.assignments) * 100
                              )}
                              %
                            </Text>
                          )}
                      </div>
                      <Text type="b4">
                        {item?.published ? 'Visibile' : 'Non visibile'}
                      </Text>
                      <Text type="b4">
                        {timestampToDate(item?.publication_date)}
                      </Text>
                    </CourseCard>
                  ))}
                </CardsWrapper>
                <Pagination
                  pager={pager}
                  callBack={loadMore}
                  setItemsPerPage={setItemsPerPage}
                />
              </>
            ) : (
              <NoResult />
            )}
          </>
        )}
      </Container>
      <ModalUserList />
    </>
  );
};

TutorStatistics.propTypes = {
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  // HOC: state
  list: PropTypes.array,
  filters: PropTypes.object,
  pager: PropTypes.object,
  myUsers: PropTypes.object,
  ffoo: PropTypes.array,
  user: PropTypes.object,
  // HOC: dispatch
  modalOpen: PropTypes.func.isRequired,
  getCourseCreatedList: PropTypes.func.isRequired,
  getMyUsers: PropTypes.func,
  getFfoo: PropTypes.func,
  getUserStats: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { list, filters, pager } = state.statistics.course.createdCourses;
      const { myUsers } = state.statistics.charts;
      const { ffoo } = state.courselist;
      const { user } = state.statistics;
      return {
        list,
        filters,
        pager,
        myUsers,
        ffoo,
        user,
      };
    },
    (dispatch) => ({
      modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
      getCourseCreatedList: (filters) =>
        dispatch({ type: COURSE_CREATED_LIST_GET._REQUEST, filters }),
      getMyUsers: (filters) =>
        dispatch({
          type: MY_USERS_GET._REQUEST,
          filters,
          status_array: ['assignments', 'fruitions', 'completions'],
        }),
      getFfoo: () => dispatch({ type: FFOO_GET._REQUEST }),
      getUserStats: ({ user_id }) =>
        dispatch({ type: USER_STATS_GET._REQUEST, user_id }),
    })
  ),
  withMediaQueries
)(TutorStatistics);
